// Mock data for portfolio

export const personalInfo = {
  name: "Jerathel Czerny",
  title: "Software Developer",
  location: "Derry, NH, United States",
  email: "jerathelczerny@yahoo.com",
  phone: "(917)751-7033",
  bio: "Full-stack software developer with 7+ years of experience architecting secure, scalable, and high-performance web and production applications.Skilled in building and deploying responsive, accessible, cross-browser interfaces with HTML5, CSS3, JavaScript, TypeScript, and React;integrating RESTful APIs and databases; and designing back-end services with Node.js, Python/Django, and C#/.NET. Experienced with distributed systems, event-driven architecture, AWS and Microsoft Azure, SQL/NoSQL databases, OAuth2/OpenID Connect/JWT authentication,automated testing, CI/CD, observability, performance optimization, security protocols, documentation, and supporting production systems.Passionate about emerging technologies, DevOps automation, and enterprise-grade digital platforms.",
  portfolio: "a-jerathel-portfolio.vercel.app",
  linkedin: "https://www.linkedin.com/in/jerathel-czerny-323132163",
  github: "github.com/jera66",
};

export const projects = [
  {
    id: 1,
    name: "Marketing Agency Website",
    description:
      "Designed and developed a fully custom WordPress theme from scratch using PHP. Implemented custom post types, reusable template components inspired by React, and focused on performance, accessibility, and SEO. Delivered a responsive, agency-quality website without page builders.",
    technologies: ["WordPress", "PHP", "HTML5", "CSS3", "JavaScript"],
    category: "PHP",
    image: "/assets/marketing_agency.png",
    link: "https://github.com/jera66/marketing-agency",
    featured: true,
  },
  {
    id: 2,
    name: "Nexus Commerce",
    description:
      "Nexus Commerce is an enterprise-grade e-commerce Content Management System designed to combine the flexibility of a modern CMS with the operational depth of a serious commerce platform.",
    technologies: ["React", "TypeScript", "Vite", "Zod", "TanStack Query", "PostgreSQL", "Node.js", "Express"],
    category: "Enterprise",
    image: "/assets/nexus-commerce-homepage.png",
    link: "https://github.com/jera66/nexus-commerce",
    featured: true,
  },
  {
    id: 3,
    name: "Rosathel PMS",
    description:
      "A luxury hotel booking application built with the MERN stack. Features include personalized guest dashboards, reward points system, digital room keys, booking management, and seamless check-in experience. Emphasizes elegant UI design, component reusability, clean state management, and premium user experience.",
    technologies: ["MongoDB", "Express", "React", "Node.js"],
    category: "React",
    image: "/assets/rosathel_suites.png",
    link: "https://github.com/jera66/rosathel-suites-client",
    featured: true,
  },
{
    id: 4,
    name: "Software Developer Portfolio",
    description: "A stunning, fully responsive, production-ready portfolio website featuring a unique neumorphic design with navy blue and burgundy theme colors. Built with modern web technologies to showcase professional experience, projects, and skills with an emphasis on beautiful UI/UX design.ent, and seamless check-in experience. Emphasizes elegant UI design, component reusability, clean state management, and premium user experience.",
    technologies: ["React", "React Router DOM", "Tailwind CSS", "Lucide React", "Axios", "Shadcn/ui components","FastApi", "MongoDB with motor", "Pydantic"],
    category: "React",
    image: "/assets/portfolio_screenshot.png",
    link: "https://github.com/jera66/myportfolio_frontend",
    featured: true
  },
  {
    id: 5,
    name: "VLOSA - Virtual Life Operating System Agent",
    description: "is a comprehensive personal automation platform designed to manage your digital life intelligently. It combines inbox management, task tracking, AI-powered communication assistance, and rule-based automation into a unified system available on both web and mobile. VLOSA uses advanced AI to help you stay organized, prioritize tasks, and automate routine activities, making it an essential tool for anyone looking to optimize their productivity and digital organization.",
    technologies: ["Vite", "React Router DOM", "React Lucid", "Tailwind CSS", "Motion"],
    category: "Enterprise",
    image: "/assets/vlosa_screenshot.png",
    link: "https://github.com/jera66/vlosa",
    featured: true
  },
  {
    id: 6,
    name: "FreightFlow",
    description: "FreightFlow is a production-oriented freight and logistics platform for shippers, operations teams, dispatchers, customer service, finance teams, and administrators. It unifies quoting, booking, shipment execution, live tracking, documents, billing, payments, notifications, reporting, and auditability in one secure platform.",
    technologies: ["React", "TypeScript", "Vite", "State Redux Toolkit", "TanStack Query", "Styling Tailwind CSS + component-scoped styling"],
    category: "Enterprise",
    image: "/assets/freightflow-home-reference.png",
    link: "https://github.com/jera66/freightflow",
    featured: true
  },
  {
    id: 7,
    name: "ConsentMesh",
    description: "ConsentMesh is a comprehensive consent management platform designed to streamline the process of obtaining, managing, and tracking user consents across various digital touchpoints. It provides a centralized solution for ensuring compliance with data protection regulations and enhancing user trust.",
    technologies: ["React", "TypeScript", "Vite", "State Redux Toolkit", "TanStack Query", "Styling Tailwind CSS + component-scoped styling", "C# / .NET 8", "ASP.NET Core", "Microsoft Azure", "Azure Service Bus", "Azure SQL", "Azure Cosmos DB", "Microsoft Entra ID", "OAuth 2.0", "OpenID Connect", "JWT", "Entity Framework Core", "Distributed Systems", "Event-Driven Architecture", "Microservices", "Docker", "OpenTelemetry", "Application Insights", "Azure Key Vault", "Azure API Management", "GitHub Actions", "CI/CD", "REST APIs", "Policy-Based Authorization", "RBAC", "Idempotency", "Transactional Outbox Pattern", "Dead-Letter Queues", "Retries + Circuit Breakers", "Health Checks", "Structured Logging", "Distributed Tracing", "Automated Testing"],  
    category: "Enterprise",
    image: "/assets/ConsentMesh.png",
    link: "https://github.com/jera66/consentmesh",
    featured: true
  }
];

export const experience = [
  {
    id: 1,
    title: "Software Developer",
    company: "Czerny Systems",
    period: "Jan 2026 - Present",
    location: "Remote",
    responsibilities: [
      "Design and implement scalable full‑stack applications and services using React, Node.js, Python, and",
      "cloud‑native architectures.Develop RESTful APIs and microservices, improving system reliability and maintainability through modular design and automated testing.",
      "Collaborate with product managers, architects, QA engineers, and stakeholders to gather requirements and drive technical design and delivery.",
      "Manage CI/CD pipelines and deployment automation to increase release predictability and reduce manual intervention.",
      "production incidents and implement performance optimizations to improve application stability and responsiveness.",
    ],
  },
  {

    id: 2,
    title: "Front End Developer",
    company: "Independent / Project-Based",
    period: " Feb 2022 - May 2026",
    location: "Remote",
    responsibilities: [
      "Developed React interfaces and API integrations that reduced page load times and improved data accuracy.",
      "Built reusable component library to accelerate feature delivery and simplify cross-team maintenance.",
      "Implemented automated testing and CI/CD pipelines to increase deployment reliability and shorten release cycles.",
      "Collaborated with stakeholders to translate requirements into secure, scalable web solutions with measurable business impact.",
    ],
  },
  {
    id: 3,
    title: "React Developer",
    company: "Ali Tech Solutions",
    period: "Mar 2023 - Aug 2024",
    location: "Remote",
    responsibilities: [
      "Developed multi-tier API services to integrate large datasets, improving data availability for web apps.",
      "Built React-based interfaces that improved user task completion rates and responsiveness.",
      "Designed and deployed scalable backend components that increased throughput with measurable results.",
      "Collaborated with cross-functional teams to deliver client-specific web applications on schedule.",
    ],
  },
  {
    id: 4,
    title: "Full-Stack Development Intern",
    company: "DecodeLabs",
    period: "Jun 2021 - Feb 2022",
    location: "Remote/Cambridge, MA",
    responsibilities: [
      "Architected foundational components for internal web platforms using React, Node.js, Python/Django, HTML, CSS, and JavaScript, emphasizing modularity and scalability.",
      "Built secure RESTful APIs and authentication workflows with OAuth2, JWT, and role-based access control in alignment with OWASP best practices.",
      "Assisted with AWS deployments using EC2, S3, Lambda, and RDS, including serverless functions that reduced operational overhead.",
      "Collaborated with senior engineers on HIPAA-aware data flows, encryption strategies, secure storage patterns, and security protocols for sensitive diagnostic data.",
      "Contributed to e-commerce and analytics prototypes by integrating Stripe payments, behavior tracking, dashboards, and data-visualization tools.",
      "Participated in penetration testing, identified vulnerabilities, and implemented fixes that strengthened platform security.",
      "Supported Docker, Git, automated testing, and CI/CD initiatives for repeatable builds and deployments.",
      "Created technical documentation and presented progress updates and architectural recommendations to technical and non-technical stakeholders."
    ],
  },
];

export const education = [
  {
    id: 1,
    degree: "Data Science",
    institution: "Arizona State University Digital Immersion",
    period: "Jan 2025 - Aug 2025",
    format: "Online",
  },
  {
    id: 2,
    degree: "Software Engineering",
    institution: "Southern New Hampshire University",
    period: "Apr 2019 - Jan 2023",
    format: "Online",
  },
];

export const skills = {
  languages: [
    "JavaScript",
    "React",
    "HTML5",
    "CSS3",
    "WordPress",
    "PHP",
    "Git",
    "Java",
    "Python",
    "TypeScript",
    "Node.js",
    "C#",
    "SQL",
    "NoSQL",
  ],
  design: [
    "Mobile-First Design",
    "Responsive Design",
    "Accessibility",
    "Cross-Browser Compatibility",
    "Performance Optimization",
    "Component-Based Architecture",
    "Agile Workflows",
  ],
  tools: ["Gulp", "Grunt", "Postman", "Figma"],

  otherSkills: [
    "Problem Solving",
    "Team Collaboration",
    "Effective Communication",
    "Time Management",
    "Adaptability",
    "Continuous Learning",
  ],
};




